import { makeAutoObservable } from 'mobx';
import { createUUID } from 'utils/helpers';

export interface INotification {
	id: string;
	message: string;
	title?: string;
	confirmable?: boolean;
}

export class NotificationsStore {
	queue: Array<INotification> = [];

	constructor() {
		makeAutoObservable(this);
	}

	addNotification = ({
		title,
		message,
		confirmable,
	}: {
		title?: string;
		message: string;
		confirmable?: boolean;
	}): void => {
		const id = createUUID();

		this.queue.push({ title: title, message: message, id: id, confirmable: confirmable });

		if (!confirmable) {
			setTimeout(() => this.removeNotification(id), 3000);
		}
	};

	removeNotification = (id: string) => {
		const index = this.queue.map((item) => item.id).indexOf(id);
		if (index >= 0) this.queue.splice(index, 1);
	};
}

export default NotificationsStore;
